import uniqBy from "lodash/uniqBy";
import { z } from "zod";

import { ProcessStepCatalogDto } from "#modules/quoteRequestLines/infra/fetchProcessStepCatalog.api";
import { SurfaceTreatmentsPredictionsDto } from "#modules/quoteRequestLines/infra/fetchSurfaceTreatmentsPredictions.api";
import { PartialProcessStep } from "#modules/quoteRequestLines/views/DetailsPanel/ProcessSteps/ProcessStep";
import { getIndustrialProcessWording } from "#shared/helpers/getIndustrialProcessWording";
import { IndustrialProcessSchema } from "shared";

const industrialProcessesToHideInList = z.enum([
  IndustrialProcessSchema.enum.SIMPLE,
  IndustrialProcessSchema.enum.MATERIAL,
  IndustrialProcessSchema.enum.PRODUCTS,
]);

export const predictedProcessStepsAdapter = (
  processSteps: ProcessStepCatalogDto | SurfaceTreatmentsPredictionsDto | null | undefined,
): PartialProcessStep[] => {
  if (!processSteps) {
    return [];
  }

  return uniqBy(
    processSteps.filter(
      (processStep) =>
        industrialProcessesToHideInList.safeParse(processStep.industrialProcess).error,
    ),
    (item) => item.description || getIndustrialProcessWording(item.industrialProcess),
  );
};
